export default __webpack_public_path__ + "static/media/termite.08485db9.pdf";